package com.shadowings.gero.presentation.model

/**
 * Raggruppa tutte le azioni legate ai cuori, evitando il prop drilling
 * di callback singole attraverso NavGraph → QuizScreen → NoHeartsScreen.
 */
data class HeartActions(
    val removeOne: (isCorrect: Boolean) -> Unit = {},
    val buyFullVersion: () -> Unit = {},
    val restoreFullVersion: () -> Unit = {},
    val watchAdForHearts: () -> Unit = {},
    val isFullVersionUnlocked: Boolean = false,
    val isPurchaseReady: Boolean = false,
    val adStatus: RewardedAdStatus = RewardedAdStatus.LOADING,
)
